/** The email links to /sign-in/link#token=…: the token stays out of server logs and Referer. */
export function readLinkToken(hash: string): string | null {
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const token = params.get('token')?.trim();
  return token ? token : null;
}
